import React, { useEffect, useRef, useState } from 'react';
import { BlurbText, ShowMoreButton, Wrapper } from './SrpBlurb.style';
import { sanitize } from '../../../common/helpers/utility/sanitizer';
import commonResource from '../../../locales/th/common.json';
import { DownOutlined } from '@ant-design/icons';

interface Props {
  text?: string;
}

const SrpBlurb: React.FunctionComponent<Props> = ({ text }) => {
  const blurbTextElementRef = useRef(null);
  const [isShowMoreVisible, setIsShowMoreVisible] = useState(true);

  useEffect(() => {
    const actualElement = blurbTextElementRef?.current;
    if (actualElement) {
      setIsShowMoreVisible(
        actualElement.scrollHeight !== actualElement.offsetHeight,
      );
    }
  }, []);

  const onClickShowMore = () => {
    setIsShowMoreVisible(false);
  };

  return (
    <Wrapper>
      {text && (
        <BlurbText
          data-test="srp-blurb"
          ref={blurbTextElementRef}
          showAll={!isShowMoreVisible}
          dangerouslySetInnerHTML={{ __html: sanitize(text) }}
        ></BlurbText>
      )}
      {text && isShowMoreVisible && (
        <ShowMoreButton onClick={onClickShowMore}>
          {commonResource.showMore.More}
          <DownOutlined />
        </ShowMoreButton>
      )}
    </Wrapper>
  );
};

export default SrpBlurb;
